import * as React from "react";
import { Grid } from "@material-ui/core";
import WMLogoReport from "../../../assets/icons/WMLogoReport";
import { SessionCache } from "../../../helpers/cache";
import User from "../../../core/models/User";
import { formatDateTime } from "../../../helpers/datetime";

type ReportGridProps = {
  headerReport: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: React.ReactNode;
};

function ReportGrid({ headerReport, children }: ReportGridProps) {
  const style = {
    display: "flex",
    flex: "1",
    justifyContent: "space-between",
    alignItems: "center",
    height: "80px",
    paddingLeft: "2",
    backgroundColor: "white",
    fontFamily: "Linde,Arial,Roboto,-apple-system,sans-serif",
  };

  const StorageCache = new SessionCache();
  const user: User | null = StorageCache.get("user");

  return (
    <Grid container style={{ padding: "20px 20px 20px 20px" }}>
      <Grid item xs="auto">
        <div style={style}>
          <div>
            <div style={{ fontSize: "1.60rem", fontWeight: "bold" }}>{headerReport}</div>
            <div style={{ fontSize: "1rem", color: "gray" }}>
              Emitido por {user?.name} em {formatDateTime(new Date(), "dd/MM/yyyy")}
            </div>
          </div>
          <div style={{ width: "318px" }}>
            <WMLogoReport />
          </div>
        </div>
        <div>{children}</div>
      </Grid>
    </Grid>
  );
}

export default ReportGrid;
